import EndpointsBase from "../EndpointsBase";
import { IExtendedSortBoxItemModel } from "../SortBoxItem/IExtendedSortBoxItemModel";

class SortBoxEndpoints extends EndpointsBase {
  getNextSortBox(
    fullCartNumber: string,
    previousShelfID: number,
    scan: string,
    forceShelf: number = -1,
    prioDeadlineID: number = -1,
    lastInstructionID: number = -1
  ) {
    return this._sendRequest({
      method: `sortbox/getNextSortBox/`,
      headers: this._getAuthHeader(),
      data: {
        fullCartNumber,
        previousShelfID,
        scan,
        forceShelf,
        prioDeadlineID,
        lastInstructionID,
      },
      run: this.server.getData,
    });
  }

  getFullOrderRX(
    boxID: number 
  ) {
    return this._sendRequest({
      method: 'sortbox/getrxcurrentfullorder',
      headers: this._getAuthHeader(),
      data: {
        sortBoxID: boxID
      },
      run: this.server.getData,
    });
  };

  getSortBoxItems(
    fullCartNumber: string,
    previousShelfID: number,
    scan: string,
    forceShelf: number = -1,
    prioDeadlineID: number = -1,
    lastInstructionID: number = -1,
    skuID: number = -1
  ) {
    return this._sendRequest({
      method: `sortbox/getsortboxitems/`,
      headers: this._getAuthHeader(),
      data: {
        fullCartNumber,
        previousShelfID,
        scan,
        forceShelf,
        prioDeadlineID,
        lastInstructionID,
        skuID,
      },
      run: this.server.getData,
    });
  }

  extendSortboxLockExpiration(sortBoxID: number) {
    return this._sendRequest({
      method: "sortbox/extendlockexpiration",
      headers: this._getAuthHeader(),
      data: {
        sortBoxID,
      },
      run: this.server.postData,
    });
  }
  getLastUnfinishedCartID(operatorID: number, workstationID: number) {
    return this._sendRequest({
      method: `sortbox/GetLastUnfinishedCartID/`,
      headers: this._getAuthHeader(operatorID, workstationID),
      data: {},
      run: this.server.getData,
    });
  }

  shippingContainerScan = (
    packageNumber: string,
    containerBarcode: string,
    operatorID: number,
    companyID: number,
    workstationID: number
  ) => {
    return this._sendRequest({
      method: "sortbox/setshippingcontainer",
      headers: this._getAuthHeader(operatorID, workstationID, companyID),
      data: {
        containerBarcode,
        packageNumber,
      },
      run: this.server.postData,
    });
  };

  getLeftoverOrders = (workstationID: number, operatorID: number) => {
    return this._sendRequest({
      method: "sortbox/leftoverorders",
      headers: this._getAuthHeader(operatorID, workstationID),
      data: {},
      run: this.server.getData,
    });
  };
  finalizeSortbox(
    sortBoxID: number = -1,
    iPackBoxBarcode: string,
    scanIDs: number[] | null = null,
    isPartialDelivery: boolean,
    scannedItems: IExtendedSortBoxItemModel[],
    aFrameControl: boolean = false,
    checkStation: number = 1
  ) {
    return this._sendRequest({
      method: "sortbox/finalizesortbox",
      data: {
        sortBoxID,
        iPackBoxBarcode,
        scanIDs,
        isPartialDelivery,
        scannedItems,
        aFrameControl,
        checkStation,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }

  finalizeSortboxNoCatch(
    sortBoxID: number = -1,
    iPackBoxBarcode: string,
    scanIDs: number[] | null = null,
    isPartialDelivery: boolean,
    scannedItems: IExtendedSortBoxItemModel[],
    aFrameControl: boolean = false,
    checkStation: number = 1
  ) {
    return this._sendRequest({
      method: "sortbox/finalizesortbox",
      data: {
        sortBoxID,
        iPackBoxBarcode,
        scanIDs,
        isPartialDelivery,
        scannedItems,
        aFrameControl,
        checkStation,
      },
      headers: this._getAuthHeader(),
      run: this.server.postDataNoErrorCatch,
    });
  }
  
  sendSuccesfullDeliveryIPackEjector(iPackBoxBarcode: string) {
    return this._sendRequest({
      method: "sortbox/sendsuccesfulldeliveryipackejector",
      data: {
        iPackBoxBarcode,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }


  putawayStock(sortBoxID: number, shelfNumber:string, isRxItem: boolean, missingQuantity: number, skuID = -1, scan="",  supplierDeliveryId: number | null =null, isLeftoverStock:boolean = false) : Promise<{supplierDeliveryId:number | null, shelfNumber:string}> {
    return this._sendRequest({
      method: "sortbox/stockputaway",
      headers: this._getAuthHeader(),
      data: {
        sortBoxID,
        shelfNumber,
        isRxItem,
        missingQuantity,
        skuID,
        scan,
        supplierDeliveryId,
        isLeftoverStock
      },
      run: this.server.postData,
    });
  }


  deleteSortBoxAndRxChildren(sortBoxID: number, ignoreRxBagDeliveredCheck:boolean) {
    return this._sendRequest({
      method: "sortbox/deleteSortBoxAndRxChildren/"+sortBoxID+"?ignoreRxBagDeliveredCheck="+ignoreRxBagDeliveredCheck,
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }

  cancelOrder(orderNumber: number) {
    return this._sendRequest({
      method: "order/cancelOrder/"+orderNumber,
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }
}

export default new SortBoxEndpoints();
